// extracted by mini-css-extract-plugin
export default {"fullscreen":"protocol-component_fullscreen__-Y-2X","content":"protocol-component_content__o0N4V"};